import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";
import "./CandidateHeader.css";

const CandidateHeader = ({ withSpacer = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    document.body.classList.add("candidate-page-active");

    return () => {
      document.body.classList.remove("candidate-page-active");
    };
  }, []);

  const currentTab = new URLSearchParams(location.search).get("tab");
  const isApplicationsActive =
    location.pathname === "/candidate/candidatedashboard" &&
    currentTab === "applications";
  const isProfileActive =
    location.pathname === "/candidate/candidatedashboard" &&
    currentTab === "profile";
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <>
      <header className="candidate-shared-header">
        <div className="candidate-shared-header__inner">
          <Link to="/" className="candidate-shared-header__brand">
            BlackRoth<span className="candidate-shared-header__trademark">TM</span>
          </Link>

          <div className="candidate-shared-header__actions">
            <button
              type="button"
              className={`candidate-shared-header__button ${isApplicationsActive ? "active" : ""}`}
              onClick={() =>
                navigate("/candidate/candidatedashboard?tab=applications")
              }
            >
              My Applications
            </button>

            <button
              type="button"
              className={`candidate-shared-header__button ${isProfileActive ? "active" : ""}`}
              onClick={() =>
                navigate("/candidate/candidatedashboard?tab=profile&view=profile-only")
              }
            >
              <span className="candidate-shared-header__icon" aria-hidden="true">
                <span className="eye left"></span>
                <span className="eye right"></span>
                <span className="mouth"></span>
              </span>
              Candidate Panel
            </button>

            <button
              type="button"
              className="candidate-shared-header__logout"
              onClick={handleLogout}
            >
              Logout <FaSignOutAlt />
            </button>
          </div>
        </div>
      </header>

      {withSpacer && <div className="candidate-shared-header__spacer" />}
    </>
  );
};

export default CandidateHeader;
